import { Box } from '@mui/material';
import TicketItem from 'features/tickets/components/ticket-item/ticket-item';

const RegisterTicketStep = (): JSX.Element => {
    return (
        <Box
            sx={{
                minHeight: { xs: '62dvh', sm: 0 },
                flex: 1,
                overflow: 'hidden',
            }}>
            <TicketItem
                routing="/register/ticket"
                headerActionsTargetId="register-ticket-header-actions"
            />
        </Box>
    );
};

export default RegisterTicketStep;
